import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import "./global-style.css"; // the global Motif stylesheet
import "./docs.module.css"; // custom docs stylesheet

ReactDOM.render(<App />, document.getElementById("root"));
